export default {
  'payeeImport.reviewPayeeUpload.title': 'Review Payee Upload',
  'payeeImport.reviewPayeeUpload.overviewInformation': 'Overview Information',
  'payeeImport.reviewPayeeUpload.messageDescription': 'Message Description',
  'payeeImport.reviewPayeeUpload.firstTenErrorMsgs':
    'Displaying first 10 upload errors only.  The following records will not be included with import.',
  'payeeImport.reviewPayeeUpload.cannotBeUploaded': 'File cannot be uploaded',
  'payeeImport.reviewPayeeUpload.uploadCriteriaNotMet': 'Upload Criteria not met.',
  'payeeImport.reviewPayeeUpload.errorLimitExceeded': 'More than 10 errors found.',
  'payeeImport.reviewPayeeUpload.tryAgain': 'Try again',
  'payeeImport.uploadSuccessMessage': 'File Successfully Imported'
};
